import styled from 'styled-components'
import { DatePicker } from 'antd'

export const DateRangePicker = styled(DatePicker.RangePicker)`
  width: 240px;
`